import { type ReactElement } from 'react';

import { useTranslation } from 'react-i18next';

import { Button, Icon } from '@wf/components';

interface IEmptyContentView {
  showCreateButton: boolean;
  onCreateItem?: () => void;
  showMessage: boolean;
  buttonText?: string;
  text?: string;
  button?: ReactElement;
  header?: ReactElement;
}

function EmptyContentView({
  showCreateButton,
  onCreateItem,
  showMessage,
  header,
  text,
  button,
  buttonText = 'Create',
}: IEmptyContentView) {
  const { t } = useTranslation();

  return (
    <div className="h-100 relative">
      {header}
      <div className="flex flex-column items-center content-center h-100">
        <Icon size={30} name="il_document" />
        {showMessage && text && <span className="fs-16 fw-semibold p-t-12">{t(text)}</span>}
        {showCreateButton &&
          (button ? (
            button
          ) : (
            <Button onClick={onCreateItem} type="button" className="m-t-12">
              {t(buttonText)}
            </Button>
          ))}
      </div>
    </div>
  );
}

export default EmptyContentView;
